module.exports = __webpack_public_path__ + "img/8.61ec1257.png";